import PortalIdParser from 'PortalIdParser';
import { CMS_HUB_ENTERPRISE, CMS_HUB_PROFESSIONAL, COMMERCE_HUB_PROFESSIONAL, MARKETING_HUB_ENTERPRISE, MARKETING_HUB_PROFESSIONAL, MARKETING_PLUS_ENTERPRISE_BUNDLE, MARKETING_PLUS_PROFESSIONAL_BUNDLE, OPERATIONS_HUB_ENTERPRISE, OPERATIONS_HUB_PROFESSIONAL, SALES_HUB_ENTERPRISE, SALES_HUB_PROFESSIONAL, SERVICE_HUB_ENTERPRISE, SERVICE_HUB_PROFESSIONAL } from 'self-service-api/constants/ApiNames';
const portalId = PortalIdParser.get();
export const navigateTo = url => {
  if (window.hubspot.wordpress) {
    window.open(url, '_top');
  } else {
    window.location.href = url;
  }
};
export const getTrialGuideUrl = (apiName, source) => {
  return `/trial-guide/${portalId}/${apiName}${source ? `?source=${source}` : ''}`;
};
export const getGlobalHomeUrl = () => `/global-home/${portalId}`;
const trialsGoingToGlobalHome = [CMS_HUB_ENTERPRISE, MARKETING_HUB_ENTERPRISE, MARKETING_PLUS_ENTERPRISE_BUNDLE, OPERATIONS_HUB_ENTERPRISE, SALES_HUB_ENTERPRISE, SERVICE_HUB_ENTERPRISE];
const trialsWithTrialGuide = [CMS_HUB_PROFESSIONAL, COMMERCE_HUB_PROFESSIONAL, MARKETING_HUB_PROFESSIONAL, MARKETING_PLUS_PROFESSIONAL_BUNDLE, OPERATIONS_HUB_PROFESSIONAL, SALES_HUB_PROFESSIONAL, SERVICE_HUB_PROFESSIONAL];
export const handleTrialStartSuccess = ({
  apiName,
  source
}) => {
  var _window$opener;
  if (typeof window !== 'undefined' && (_window$opener = window.opener) !== null && _window$opener !== void 0 && _window$opener.location.href) {
    navigateTo(window.opener.location.href);
  } else if (trialsWithTrialGuide.includes(apiName)) {
    navigateTo(getTrialGuideUrl(apiName, source));
  } else if (trialsGoingToGlobalHome.includes(apiName)) {
    navigateTo(getGlobalHomeUrl());
  } else {
    window.location.reload();
  }
};
const redirectRoutes = {
  'landing-pages': `/pages/${portalId}/manage/landing`,
  email: `/email/${portalId}/manage`,
  'marketing-workflows': `/workflows/${portalId}`,
  'content-strategy': `/content-strategy/${portalId}/clusters`,
  'sales-workflows': `/workflows/${portalId}`,
  playbooks: `/playbooks/${portalId}`,
  sequences: `/sequences/${portalId}`,
  quotes: `/quotes/${portalId}`,
  tickets: `/contacts/${portalId}/tickets/list/view/all`,
  feedback: `/feedback/${portalId}/home`,
  'knowledge-base': `/knowledge/${portalId}/insights/dashboard`,
  'service-workflows': `/workflows/${portalId}`,
  meetings: `/meetings/${portalId}`,
  'user-settings': `/settings/${portalId}/users?createUserEmail`,
  social: `/social/${portalId}/`,
  seo: `/content-strategy/${portalId}/recommendations`,
  forecasting: `/forecasting/${portalId}`,
  'live-messages-settings': `/live-messages-settings/${portalId}`,
  'custom-coded-workflow-actions': `/workflows/${portalId}`,
  'custom-coded-bot-actions': `/chatflows/${portalId}`,
  webhooks: `/workflows/${portalId}`,
  'data-quality-automation': `/workflows/${portalId}`,
  campaigns: `/marketing/${portalId}/campaigns`,
  datasets: `/advanced-builder/${portalId}/dataset`,
  'snowflake-data-share': `/ecosystem/${portalId}/marketplace/apps/productivity/connector/snowflake`,
  payments: `/settings/${portalId}/sales/payments`
};
export const mapRedirectTargetToRouteFromApiName = (redirectTarget, apiName) => {
  if (redirectTarget !== 'other' && redirectRoutes[redirectTarget]) {
    return redirectRoutes[redirectTarget];
  }
  const hub = apiName ? apiName.split('-')[0] : '';
  return `/reports-dashboard/${portalId}/${hub}`;
};